module.exports = __webpack_public_path__ + "img/0Q3B1666_L_Black_MockedUp.b628314d.jpg";